app.service('productStateOutletModal', function (modal, modalDelivery, productCardConfig, store, front, loading, stackedModal, sufficientOutletProductList) {

	let $modal, $self, $currentOutlet;

	function show() {
		load();
	}

	function setElements() {
		$self = $('#outlet-modal');
	}

	function setEvents() {
		$self.on('click', '.js-select-outlet', changeCurrentOutletItem)
			.on('click', '.js-outlet-modal-home-delivery', openDeliveryModal);
	}

	function setCurrentOutletItem() {
		if (store.data.isOutlet) {
			$currentOutlet = $(`#outlet-item-${store.data.outletCategoryId}`);
			if ($currentOutlet.length) {
				$currentOutlet.addClass('active-outlet-item');
			}
		}
	}

	function changeCurrentOutletItem() {
		if ($currentOutlet && $currentOutlet.length) {
			$currentOutlet.removeClass('active-outlet-item');
		}

		$currentOutlet = $(this).closest('.outlet-product-item');
		let outletCategoryId = $(this).data('category-id');

		$currentOutlet.addClass('active-outlet-item');

		if (store.data.isInstalment) {
			store.dispatch('setDefaultOutletContext', { outletCategoryId });
		} else {
			store.dispatch('setOutletState', { outletCategoryId });
		}

		UA.pageInteraction('CTA', 'Opcje zakupowe - Stan ' + $currentOutlet.data('state'));

		$modal.close();
	}

	function load() {
		loading.start();

		$.ajax({
			url: '/web-cached/product-detail/outlet-states.ltr',
			data: {
				productId: productCardConfig.getData().id
			},
			success: function (html) {
				loadSuccess(html);
			},
			error: function () {
				modal.alert('Błąd pobierania danych outletowych');
			},
			complete: function () {
				loading.stop();
			}
		});
	}

	function loadSuccess(html) {
		$modal = modal.generate({
			id: 'outlet-modal',
			content: html,
			callbackOpen: function () {
				setElements();
				setEvents();
				setCurrentOutletItem();
				if(front.ole) {
					sufficientOutletProductList.init(this.$modal);
				}
			}
		});

		stackedModal.push($modal);
	}

	function openDeliveryModal() {
		const outletCategoryId = $(this).data('outletCategory');
		const productId = productCardConfig.getData().id;
		modalDelivery.showModal({
			productId,
			outletCategoryId
		});
		UA.pageInteraction('CTA', 'Sprawdź termin dostawy');
	}

	return {
		show: show
	};
});